export var PlayerLayout;
(function (PlayerLayout) {
    PlayerLayout["MINIMIZED"] = "minimized";
    PlayerLayout["FULLSCREEN"] = "fullscreen";
    PlayerLayout["RELATIVE"] = "relative";
})(PlayerLayout || (PlayerLayout = {}));
export var ILiveStreamState;
(function (ILiveStreamState) {
    ILiveStreamState["ACTIVE_WAITING"] = "ACTIVE_WAITING";
    ILiveStreamState["ACTIVE_PLAYING"] = "ACTIVE_PLAYING";
    ILiveStreamState["ACTIVE_PAUSED"] = "ACTIVE_PAUSED";
    ILiveStreamState["REPLAY_PLAYING"] = "REPLAY_PLAYING";
})(ILiveStreamState || (ILiveStreamState = {}));
